import axiosClient from "./axiosClient";

const searchProperty = (params) => {
  const url = `/properties/search`;
  return axiosClient.get(url, params);
};
const postProperty = (params) => {
  const url = "/properties";
  return axiosClient.post(url, params);
};
const putProperty = (params, id) => {
  const url = `/properties/${id}`;
  return axiosClient.put(url, params);
};

const getPropertyDisclaimers = (params) => {
  const url = `/properties/disclaimers`;
  return axiosClient.get(url, { params });
};

const getProperty = () => {
  const url = `/properties`;
  return axiosClient.get(url);
};

const getPropertyIncides = (params) => {
  const url = `/properties/indices`;
  return axiosClient.get(url, params);
};
const getPropertyPriceHistory = () => {
  const url = `/properties/priceHistory`;
  return axiosClient.get(url);
};

const deleteProperty = (id) => {
  const url = `/properties/${id}`;
  return axiosClient.delete(url);
};

const getPropertyDetails = (propertyId) => {
  const url = `/properties/details/${propertyId}`;
  return axiosClient.get(url);
};

export {
  searchProperty,
  getPropertyPriceHistory,
  postProperty,
  putProperty,
  getProperty,
  getPropertyIncides,
  deleteProperty,
  getPropertyDisclaimers,
  getPropertyDetails,
};
